import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/time-zone-converter',
  component: () => import('../../routes/TimeZoneConverter.svelte'),
  card: {
    id: 'time-zone-converter',
    title: 'Time Zone Converter',
    description: 'Convert time between any two world time zones instantly. Handles DST automatically and shows offset differences.',
    icon: 'schedule',
    iconBgClass: 'bg-cyan-50',
    iconTextClass: 'text-cyan-600',
    href: '/time-zone-converter',
    category: 'Travel & Distance',
  },
  seo: {
    title: 'Time Zone Converter – Convert Between Any World Time Zones',
    description: 'Free time zone converter to instantly convert time between any two cities or time zones worldwide. Handles daylight saving time automatically.',
  },
};

export default meta;
